
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((116|242|47)0|5119|8584|8614)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
